export const isBunnyUrl = (url: string | null | undefined) => (url || "").includes("b-cdn.net");
